<div class="row">
    <div class="col col-md-7">

        <div class="row">
            <!-- <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1 select-container">
                <label>Mode de tarification :
                    <span class="required_champs">*</span>
                </label>
                <ng-select [clearable]="false" (change)="check_if_is_famille()"
                    [(ngModel)]="itemToSave.mode_tarification_id" placeholder="Choisissez "
                    name="mode_tarification_id" id="mode_tarification_id" [multiple]="false"
                    [closeOnSelect]="true" >
                    <ng-option *ngFor="let item of itemsModeTarification" [value]="item.id">{{
                        item?.libelle }}
                    </ng-option>
                </ng-select>
            </div> -->
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                style="padding-left: 5px; padding-right: 5px">
                <label>Nombre pers. par famille:
                </label>
                <br>
                <input disabled class="form-control custom-input"
                    [(ngModel)]="itemToSave.nombre_personnes_famille"
                    name="nombre_personnes_famille" autocomplete="off" type="text"
                    mask="separator" />
            </div>
            <div class="col col-md-12">
                <div class="table-responsive">
                    <table class="table table-condensed table-hover">
                        <thead>
                            <tr class="custom-table-head">
                                <th style="width: 9%;">
                                    <a style="cursor: pointer;margin-top: 5px;"
                                        (click)="currentPage = 0;refreshListConfig()"
                                        title="Actualiser">
                                        <i class="fa fa-redo-alt"></i></a>
                                </th>
                            <tr class="custom-table-head">
        
                                <th>Statut</th>
                                <th>Plafond</th>
                                <th>Age min</th>
                                <th>Age max</th>
                                <th>Nombre autorisé</th>
                                <th>Nombre suppl. autorisé</th>
                                <th>Surprime</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style="cursor: pointer;"
                                *ngFor="let item of itemsStatutInitialized; let indice = index">
                                <td style="font-weight: 700;">{{item.libelle}}</td>
                                
                                <td>
                                    <input (input)="onInputChange()" class="form-control custom-input"
                                        [(ngModel)]="item.plafond" autocomplete="off"
                                        type="text" mask="separator"
                                        [ngModelOptions]="{standalone: true}" />
                                </td>
                                <td>
                                    <input (input)="onInputChange()" class="form-control custom-input"
                                        [(ngModel)]="item.age_min" autocomplete="off"
                                        type="text" mask="separator"
                                        [ngModelOptions]="{standalone: true}" />
                                </td>
        
                                <td><input (input)="onInputChange()" class="form-control custom-input"
                                        [(ngModel)]="item.age_max" autocomplete="off"
                                        type="text" mask="separator"
                                        [ngModelOptions]="{standalone: true}" />
                                </td>
                                <td><input [disabled]="item.codification =='A'"
                                    (input)="onInputChange()"
                                        class="form-control custom-input"
                                        [(ngModel)]="item.nombre_autorise" autocomplete="off"
                                        type="text" mask="separator"
                                        [ngModelOptions]="{standalone: true}" /></td>
        
                                <td><input (input)="onInputChange()" [disabled]="item.codification =='A'"
                                        [class.isNotConsidered]="item.nombre_autorise == 0"
                                        class="form-control custom-input"
                                        [(ngModel)]="item.nombre_supplementaire_autorise"
                                        autocomplete="off" type="text" mask="separator"
                                        [ngModelOptions]="{standalone: true}" />
                                </td>
                                <td>
                                    <input (input)="onInputChange()" [disabled]="item.codification =='A'"
                                        [class.isNotConsidered]="item.nombre_autorise == 0"
                                        class="form-control custom-input"
                                        [(ngModel)]="item.surprime_si_supplementaire"
                                        autocomplete="off" type="text" mask="separator"
                                        [ngModelOptions]="{standalone: true}" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        
    </div>

    
    <div class="col col-md-5">
        <div class="row">

            <div class="col col-md-3">
                <label>Statut
                    <span class="required_champs">*</span>
                </label>
                <ng-select [clearable]="false" [(ngModel)]="itemToAddStatutTrancheAge.statut_id"
                    placeholder="Choisissez statut" name="statut_id" id="statut_id"
                    [multiple]="false" [closeOnSelect]="true">
                    <ng-option *ngFor="let item of itemsStatut" [value]="item.id">{{
                        item?.libelle }}
                    </ng-option>
                </ng-select>
            </div>
            <div class="col col-md-2">
                <label>Age min
                </label>
                <input  class="form-control custom-input" placeholder="Age min" autocomplete="off"
                    [(ngModel)]="itemToAddStatutTrancheAge.age_min" name="age_min"  autocomplete="off"
                    type="text" mask="separator" />
            </div>
            <div class="col col-md-2">
                <label>Age max
                </label>
                <input class="form-control custom-input" placeholder="Age max" autocomplete="off"
                    [(ngModel)]="itemToAddStatutTrancheAge.age_max" name="age_max" autocomplete="off"
                    type="text" mask="separator" />
            </div>
            <div class="col col-md-3">
                <label>Prime
                </label>
                <input class="form-control custom-input" placeholder="Prime" autocomplete="off"
                    [(ngModel)]="itemToAddStatutTrancheAge.prime" name="prime" autocomplete="off" type="text"
                    mask="separator" />
            </div>
            <div class="col col-md-2" style="text-align: right;">
                <br>
                <button class="btn btn-info" (click)="onAddItemToTableTrancheAgeEtStatut()"><i
                        class="fa fa-plus"></i></button>
            </div>
        
        
            <div class="table-responsive" style="min-height:210px;overflow:auto;">
                <table class="table table-stripped table-bordered table-hover">
                    <thead>
                        <tr class="custom-table-head">
                            <th style="width: 9%;">
                                <a style="cursor: pointer;margin-top: 5px;" (click)="refreshList()"
                                    
                                title="Actualiser">
                                <i class="fa fa-redo-alt"></i></a>
                            </th>
                            <th> 
                                Statut</th>
                            <th>Age min</th>
                            <th>Age max</th>
                            <th>Prime</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of itemsPrimeByStatutAndTrancheAge; let indice = index"
                            style="cursor: pointer;">
                            <td>{{indice+1}}</td>
                            <td>{{item.statut_codification}}</td>
                            <td>{{item.age_min}}</td>
                            <td>{{item.age_max}}</td>
                            <td>{{item.prime | mask:'separator'}}</td>
                            <td><i style="color: red;" class="fa fa-trash"
                                    (click)="itemsPrimeByStatutAndTrancheAge.splice(indice,1)"></i></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            
        </div>
    </div>


</div>

